module.exports = __webpack_public_path__ + "img/ic_wallet_actived.b63db54f.svg";